import { render, staticRenderFns } from "./pinfo.vue?vue&type=template&id=61bdbd91&scoped=true&%3Ais=view&transition=fade&transition-mode=out-in&"
import script from "./pinfo.vue?vue&type=script&lang=js&"
export * from "./pinfo.vue?vue&type=script&lang=js&"
import style0 from "./pinfo.vue?vue&type=style&index=0&id=61bdbd91&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bdbd91",
  null
  
)

export default component.exports